import type { Cart } from '@src/domains/coupons/types/coupon';
import { getDiscountCurrencyInfo } from '@src/domains/coupons/core/getDiscountCurrencyInfo';

export const getCartCostPreviewDiscountCurrencyInfo = (cart: Cart) =>
  getDiscountCurrencyInfo(cart.costPreview.fullPartialAmountCurrencyInfo, cart.costPreview.totalAmountCurrencyInfo);
